﻿const Utilities = {
    formToJSON: (elements) => {
        const data = {};
        for (let i = elements.length >>> 0; i--;) {
            const split = elements[i].name.split("[");
            const prop = split[0];
            const type = elements[i].type;
            let value = elements[i].value;

            if (type === "checkbox") {
                value = elements[i].checked;
            }

            if (type === "file") {
                value = elements[i].dataset.filevalue;
            }

            if (split.length === 2) {
                if (data.hasOwnProperty(prop) === false) {
                    data[prop] = {};
                }

                const index = split[1].split("]")[0];
                data[prop][index] = value;
            } else {
                data[prop] = value;
            }
        }
        return data;
    },
    JSONToQuery: (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    },
    UnlockUi: () => {
        document.documentElement.style.removeProperty("cursor");
        document.documentElement.style.removeProperty("pointer-events");
    },
    LockUI: () => {
        document.documentElement.style.cursor = "not-allowed";
        document.documentElement.style.pointerEvents = "none";
    },
    ShowLoader: () => {
        let mainArea = document.querySelector("main");

        let existingLoader = mainArea.querySelector("[data-page-loader]");

        if (existingLoader) {
            return;
        }

        window.scrollTo(0,0);

        Array.from(mainArea.childNodes)
            .forEach(elm => {
                if (elm.style) {
                    elm.style.display = 'none';
                }
            });

        let loader = document.querySelector("body > [data-page-loader]").cloneNode(true);
        loader.style.display = 'flex';

        mainArea.appendChild(loader);
        mainArea.className = "page-bf-loading page-content colour-bg-three";
    },
    HideLoader: () => {
        let mainArea = document.querySelector("main");
        let loader = mainArea.querySelector("[data-page-loader]");

        if (loader) {
            loader.remove();
        }

        Array.from(mainArea.childNodes)
            .forEach(elm => {
                if (elm.style) {
                    elm.style.display = '';   
                }
            });
    }
}

NodeList.prototype.forEach = function(callback) {
    [].forEach.call(this, callback);
};

Array.prototype.find = function(callback) {
    for (var i = 0; i < this.length; i++) {
        if (callback(this[i])) {
            return this[i];
        }
    }

    return null;
}

Array.from = Array.from ||
    function(items) {
        var results = [];

        for (var i = 0; i < items.length; i++) {
            results.push(items[i]);
        }

        return results;
    }